import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { truncate } from "../../utils/truncate"; // Import the truncate function

const LocationDropdown = ({
  options,
  value,
  onChange,
  placeholder = "Select Location",
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value || "");

  useEffect(() => {
    if (value) {
      setSelectedOption(value);
    }
  }, [value]);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    onChange(option);
    setDropdownOpen(false);
  };

  // Truncate the selected option only if its length is greater than 5
  const displayedOption =
    selectedOption.length > 5
      ? truncate(selectedOption, 3) // Truncate to 3 characters + "..." (total 5 characters)
      : selectedOption || placeholder;

  return (
    <div className="relative">
      <div
        className="flex items-center border rounded-lg px-3 py-2 cursor-pointer focus-within:outline-none focus-within:border-agPrimary"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        {/* Location Icon */}
        <span className="material-icons-round text-agPrimary mr-2 text-lg">
          location_on
        </span>
        <span
          className={`text-sm ${
            selectedOption ? "text-agBlack" : "text-agLightGray"
          }`}
        >
          {displayedOption}
        </span>
        <span className="material-icons-round ml-auto">arrow_drop_down</span>
      </div>
      {dropdownOpen && (
        <div className="absolute z-10 mt-2 w-full bg-white border border-agGray rounded-md shadow-lg max-h-60 overflow-auto">
          <ul>
            {options.map((option, index) => (
              <li
                key={index}
                className="text-sm text-agBlack px-3 py-2 hover:bg-agPrimaryLight cursor-pointer"
                onClick={() => handleOptionChange(option)}
              >
                {option} {/* Do not truncate options inside the dropdown */}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

LocationDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default LocationDropdown;

// import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";

// const LocationDropdown = ({
//   options,
//   value,
//   onChange,
//   placeholder = "Select Location",
// }) => {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [selectedOption, setSelectedOption] = useState(value || "");

//   useEffect(() => {
//     if (value) {
//       setSelectedOption(value);
//     }
//   }, [value]);

//   const handleOptionChange = (option) => {
//     setSelectedOption(option);
//     onChange(option);
//     setDropdownOpen(false);
//   };

//   return (
//     <div className="relative">
//       <div
//         className="flex items-center border rounded-lg px-3 py-3 cursor-pointer focus-within:outline-none focus-within:border-agPrimary"
//         onClick={() => setDropdownOpen(!dropdownOpen)}
//       >
//         {/* Location Icon */}
//         <span className="material-icons-round text-agPrimary mr-2 text-lg">
//           location_on
//         </span>
//         <span
//           className={`text-sm ${
//             selectedOption ? "text-agBlack" : "text-agLightGray"
//           }`}
//         >
//           {selectedOption || placeholder}
//         </span>
//         <span className="material-icons-round ml-auto">arrow_drop_down</span>
//       </div>
//       {dropdownOpen && (
//         <div className="absolute z-10 mt-2 w-full bg-white border border-agGray rounded-md shadow-lg max-h-60 overflow-auto">
//           <ul>
//             {options.map((option, index) => (
//               <li
//                 key={index}
//                 className="text-sm text-agBlack px-3 py-2 hover:bg-agPrimaryLight cursor-pointer"
//                 onClick={() => handleOptionChange(option)}
//               >
//                 {option}
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </div>
//   );
// };

// LocationDropdown.propTypes = {
//   options: PropTypes.arrayOf(PropTypes.string).isRequired,
//   value: PropTypes.string,
//   onChange: PropTypes.func.isRequired,
//   placeholder: PropTypes.string,
// };

// export default LocationDropdown;
